import { AlertSlice, Creator } from 'store/types';

export const createAlertSlice: Creator<AlertSlice> = (set) => {
  return {
    alert: {
      visible: false,
      sentiment: 'success',
      message: '',
      buttonText: '',
      buttonAction: () =>
        set((state) => ({
          ...state,
          alert: { ...state.alert, visible: false },
        })),
    },
    setAlert: (sentiment, message, buttonText, buttonAction) =>
      set(() => ({
        alert: {
          visible: true,
          sentiment,
          message,
          buttonText,
          buttonAction: () => {
            if (buttonAction) buttonAction();
            set(() => ({
              alert: {
                visible: false,
                sentiment: 'success',
                message: '',
                buttonText: undefined,
                buttonAction: undefined,
              },
            }));
          },
        },
      })),
    clearAlert: () =>
      set(() => ({
        alert: {
          visible: false,
          sentiment: 'success',
          message: '',
          buttonText: undefined,
          buttonAction: undefined,
        },
      })),
  };
};
